<template>
    <div>Home</div>
</template>

<script>
    export default {
        name: "home",
        mounted() {
            if(this.$store.getters.isLoggedIn)
            {
                this.$router.push('/dashboard')
            }
            else
            {
                this.$router.push('/login')
            }
        }
    }
</script>

<style scoped>

</style>